import React from 'react'
import {FiRefreshCw} from 'react-icons/fi'
import {ClipLoader} from 'react-spinners';

const RefreshData = props => {
  const {loading, ...rest} = props

  return (
    <div {...rest}>
      {
        !loading ? <FiRefreshCw size={24}/> : <ClipLoader size={25} loading={loading}/>
      }
    </div>
  )
}

export default RefreshData